export const sanitizeCardNumber = (number: string): string => {
    return number.replace(/\D/g, '')
}
